module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_06-9bbf4f5d830b82b652c8c90806ee9898.svg";